import type { ReactNode } from 'react';

import type { AssetType } from '@cartwhl/common/api/getAssets';

import { MASCOT_REFERENCE_DROPZONE_HEIGHT_PX } from './MascotReferenceDropzoneEmpty';
import MascotReferenceUploadRow from './MascotReferenceUploadRow';

export type MascotReferenceFilledItem = {
  id: string;
  thumbnailUrl: string;
  assetType: AssetType;
  onRemove: () => void;
};

export interface MascotReferenceFilledPanelProps {
  items: MascotReferenceFilledItem[];
  height?: number;
  floatingAction?: ReactNode;
}

export default function MascotReferenceFilledPanel({
  items,
  height = MASCOT_REFERENCE_DROPZONE_HEIGHT_PX,
  floatingAction,
}: MascotReferenceFilledPanelProps) {
  return (
    <div
      className="bg-secondary border-primary relative flex flex-col overflow-hidden rounded-lg border"
      style={{ height }}
      onClick={(event) => event.stopPropagation()}
    >
      <div
        className={`divide-gray-30 dark:divide-gray-60 min-h-0 flex-1 divide-y overflow-y-auto ${
          floatingAction ? 'pb-10' : ''
        }`}
      >
        {items.map((item, index) => (
          <MascotReferenceUploadRow
            key={item.id}
            index={index}
            thumbnailUrl={item.thumbnailUrl}
            assetType={item.assetType}
            onRemove={item.onRemove}
          />
        ))}
      </div>
      {floatingAction ? (
        <div className="pointer-events-none absolute right-2 bottom-4">
          <div className="pointer-events-auto">{floatingAction}</div>
        </div>
      ) : null}
    </div>
  );
}
